module.exports = __webpack_public_path__ + "img/payment-in-advance.6e1fe06c.png";